import { render, staticRenderFns } from "./XDataTable.vue?vue&type=template&id=2c81cecb&scoped=true"
import script from "./XDataTable.vue?vue&type=script&lang=js"
export * from "./XDataTable.vue?vue&type=script&lang=js"
import style0 from "./XDataTable.vue?vue&type=style&index=0&id=2c81cecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81cecb",
  null
  
)

export default component.exports